import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/core/stores/auth.store';
import { organizationsService } from '@/features/organizations/api/organizations.service';
import { ORGANIZATIONS_KEYS } from '@/features/organizations/hooks/queryKeys';

export function useOrganizations() {
  const user = useAuthStore((s) => s.user);
  const tokens = useAuthStore((s) => s.tokens);

  return useQuery({
    queryKey: ORGANIZATIONS_KEYS.all,
    queryFn: ({ signal }) => organizationsService.getAll(signal),
    enabled: !!user && !!tokens,
    staleTime: 5 * 60 * 1000,
  });
}
